import { render, staticRenderFns } from "./ModalVisualizarRespostaEsclarecimentoImpugnacao.vue?vue&type=template&id=dc30480c"
import script from "./ModalVisualizarRespostaEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarRespostaEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarRespostaEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=dc30480c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports